import core from '@gin-betting/core';

import { BASE_CURRENCY } from 'app-constants';
import type { BetVariants } from 'types';
import getByKey from './getByKey';
import getEurToCurrencyRate from './getEurToCurrencyRate';
import roundBet from './roundBet';

const {
    utils: { getCurrency: getCurrencyInfo },
} = core;

const CURRENCY_BET_VARIANTS_TYPE_CONST = {
    [BASE_CURRENCY]: [3, 5, 10, 20, 50, 100],
    RUB: [200, 400, 800, 1600, 4000, 8000],
    USD: [3, 5, 10, 20, 50, 100],
    AED: [12, 20, 40, 80, 200, 400],
    AUD: [5, 9, 17, 35, 90, 170],
    BRL: [17, 30, 60, 120, 300, 600],
    BTC: [0.0005, 0.0008, 0.0015, 0.003, 0.008, 0.015],
    CAD: [5, 8, 15, 30, 80, 150],
    CNY: [25, 40, 80, 150, 400, 800],
    JPY: [350, 600, 1200, 2500, 6000, 12000],
    NOK: [35, 60, 110, 250, 600, 1100],
    SEK: [30, 50, 100, 200, 500, 1000],
    mBTC: [0.5, 0.8, 1.5, 3, 8, 15],
    UAH: [100, 150, 300, 600, 1500, 3000],
    KZT: [1500, 2500, 5000, 10000, 25000, 50000],
};

const CURRENCY_BET_VARIANTS: ExtraProps<
    typeof CURRENCY_BET_VARIANTS_TYPE_CONST
> = CURRENCY_BET_VARIANTS_TYPE_CONST;

function getBetVariants(currency: string): BetVariants {
    const currBetVariants = getByKey(CURRENCY_BET_VARIANTS, currency);

    if (currBetVariants) return currBetVariants;

    const eurToCurrencyRate = getEurToCurrencyRate(currency);

    if (!eurToCurrencyRate) return CURRENCY_BET_VARIANTS[BASE_CURRENCY];

    const betVariants = CURRENCY_BET_VARIANTS[BASE_CURRENCY].map(i =>
        roundBet(i * eurToCurrencyRate)
    );

    CURRENCY_BET_VARIANTS[currency] = betVariants;

    return betVariants;
}

export default function getCurrency() {
    const currencyInfo = getCurrencyInfo();
    const { currencyName } = currencyInfo;

    const betVariants = getBetVariants(currencyName);

    return {
        ...currencyInfo,
        betVariants,
    };
}
